import { useSearchParams } from 'react-router-dom'

import EmbedWrapper from '@src/pages/Embed/EmbedWrapper'
import RewardsPage from '@src/pages/Rewards'

const EmbedRewardsPage = () => {
    const [searchParams] = useSearchParams()

    // Parse URL parameters that are specific to this page
    // You could add Miles-specific parameters here

    return (
        <EmbedWrapper>
            <RewardsPage />
        </EmbedWrapper>
    )
}

export default EmbedRewardsPage
